import st from './index.module.css';

const cards = [1, 2, 3, 4, 5, 6, 7];

const Examples = () => {
  return (
    <div className="bg-white py-[48px] md:py-[80px]">
      <h2 className="text-center font-[500] text-[28px] md:text-[36px] mb-[32px] md:mb-[48px]">CTV գովազդի օրինակներ</h2>
      <div className={st.marqueeWrapper}>
        <div className={st.marqueeTrack}>
          {cards.map(i => (
            <div key={`a-${i}`} className={st.card}>
              <img src={`/images/smartTvAdvertising/examples/example-card-${i}.png`} alt="" />
            </div>
          ))}
          {cards.map(i => (
            <div key={`b-${i}`} className={st.card}>
              <img src={`/images/smartTvAdvertising/examples/example-card-${i}.png`} alt="" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Examples;
